import { Box, RawButton } from '@common-fe/common-fe';
import styled from 'styled-components';

const COLUMN_TRANSITION =
  'width 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)';

export const AnimatedColumn = styled(Box)`
  flex-shrink: 0;
  transition: ${COLUMN_TRANSITION};
`;

export const AnimatedCategoryName = styled(Box)`
  flex-shrink: 0;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

interface CategoryCardWrapperProps {
  $isExpanded: boolean;
}

export const CategoryCardWrapper = styled(Box)<CategoryCardWrapperProps>`
  flex-shrink: 0;
  transition: box-shadow 0.15s ease;
  box-shadow: inset 0 0 0 ${({ $isExpanded }) => ($isExpanded ? '2px' : '1px')}
    ${({ theme, $isExpanded }) => ($isExpanded ? theme.colors.border1 : theme.colors.border2)};

  &:hover {
    box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.border1};
  }
`;

export const RemoveServiceButton = styled(RawButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: ${({ theme }) => theme.rounds.button2Round};
  background-color: ${({ theme }) => theme.colors.border2};
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.danger};

    svg {
      fill: ${({ theme }) => theme.colors.iconOnColor};
    }
  }
`;
